import React from "react";

/* 라오나 키트(구 시제품 직접 만들기) 아이콘 — 헤더 핀이 달린 모듈 기판 위의 렌치.
   기판은 currentColor, 렌치는 ink 색이라 I.META 헤더 버튼과 라오나봇 헤더에서 같이 쓴다. */
export default function SelfProtoMark({ size = 28, ink = "#fff", className = "" }) {
  return (
    <svg className={`sp-mark ${className}`} width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <g fill="currentColor">
        <rect x="7" y="2" width="2.6" height="5" rx="1" />
        <rect x="12.5" y="2" width="2.6" height="5" rx="1" />
        <rect x="18" y="2" width="2.6" height="5" rx="1" />
        <rect x="23.4" y="2" width="2.6" height="5" rx="1" />
        <rect x="3" y="6" width="26" height="23" rx="5.5" />
      </g>
      <path
        d="M19.6 11.4a4 4 0 0 0-4.9 5.2l-5 5a1.6 1.6 0 0 0 2.3 2.3l5-5a4 4 0 0 0 5.2-4.9l-2.3 2.3-2.2-.6-.6-2.2z"
        fill={ink}
      />
    </svg>
  );
}
